// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { MAMode } from '../IndicatorConstants';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
import { InputParameterCombobox } from '../InputParamaterClasses/InputParameterCombobox';
export class MAE extends IndicatorScriptBase {
    constructor() {
        super();
        this.ma = null;
        this.ProjectName = 'Moving Average Envelope';
        this.Comments = 'Demonstrates a range of the prices discrepancy from a Moving Average';
        this.SetIndicatorLine('lower', Color.Purple, 1, LineStyle.SimpleChart);
        this.SetIndicatorLine('upper', Color.LightSeaGreen, 1, LineStyle.SimpleChart);
        this.SeparateWindow = false;
        this.SourcePrice = PriceType.Close;
        super.InputParameter(new InputParameterCombobox('SourcePrice', 'Sources prices for MA', 1, [
            { Close: PriceType.Close },
            { Open: PriceType.Open },
            { High: PriceType.High },
            { Low: PriceType.Low },
            { Typical: PriceType.Typical },
            { Medium: PriceType.Medium },
            { Weighted: PriceType.Weighted }
        ]));
        this.MAType = MAMode.SMA;
        super.InputParameter(new InputParameterCombobox('MAType', 'Type of moving average', 1, [
            { Simple: MAMode.SMA },
            { Exponential: MAMode.EMA },
            { Modified: MAMode.SMMA },
            { 'Linear Weighted': MAMode.LWMA }
        ]));
        this.MAPeriod = 20;
        super.InputParameter(new InputParameterInteger('MAPeriod', 'Period of MA for envelopes', 0, 1, 99999));
        this.UpShift = 10;
        super.InputParameter(new InputParameterInteger('UpShift', 'Upband deviation in %', 0, 0, 99999));
        this.DownShift = 10;
        super.InputParameter(new InputParameterInteger('DownShift', 'Downband deviation in %', 0, 0, 99999));
    }
    getMinBarsCount() {
        return this.MAPeriod;
    }
    GetIndicatorShortName() {
        return 'MAE(' + this.MAPeriod + ';' + this.UpShift + ';' + this.DownShift + ')';
    }
    getCustomName() {
        return 'MAE (' + this.ProjectName + ')';
    }
    createInternalIndicators() {
        this.ma = this.Indicators.iMA(this.CurrentData, this.MAPeriod, this.MAType, 0, this.SourcePrice);
        return [this.ma];
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count < this.MAPeriod) {
            return;
        }
        const maValue = this.ma.GetValue();
        if (!Number.isFinite(maValue)) {
            return;
        }
        this.SetValue(0, 0, maValue * (1 - this.DownShift / 100));
        this.SetValue(1, 0, maValue * (1 + this.UpShift / 100));
    }
}
